import { configureStore } from "@reduxjs/toolkit";
import hostSettingsReducer, {
  fetchData as fetchHostSettingsSliceData,
} from "./hostSettingsSlice";
import userReducer, { fetchUserData } from "./userSlice/userSlice";
import { authApi } from "../helper/auth/login-api";

export const store = configureStore({
  reducer: {
    hostSettings: hostSettingsReducer,
    user: userReducer,
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware),
});

// Dispatch the fetchData actions when the store is configured
store.dispatch(fetchUserData());
store.dispatch(fetchHostSettingsSliceData());
